import type { Identifier } from "ra-core";

import type { MarketIdea } from "./types";

export const MARKET_BASE = "/inteligencia";

export type MarketTab = "daily" | "weekly" | "opportunities" | "ideas";

export const MARKET_TABS: readonly { id: MarketTab; path: string }[] = [
  { id: "daily", path: "diario" },
  { id: "weekly", path: "semanal" },
  { id: "opportunities", path: "prospectos" },
  { id: "ideas", path: "ideas" },
];

/** Section of a /inteligencia/... path ("daily" by default). */
export const tabOfPath = (pathname: string): MarketTab => {
  const segment = pathname.slice(MARKET_BASE.length + 1).split("/")[0];
  return MARKET_TABS.find((tab) => tab.path === segment)?.id ?? "daily";
};

export const dailyPath = (date?: string): string =>
  `${MARKET_BASE}/diario${date ? `?fecha=${date}` : ""}`;

/** Opens the report containing the item, scrolled to it. */
export const dailyItemPath = (itemId: Identifier): string =>
  `${MARKET_BASE}/diario?noticia=${encodeURIComponent(String(itemId))}`;

/**
 * Opens the Ideas tab on the idea's status (the phone lists one status at a
 * time) with the idea highlighted and scrolled into view.
 */
export const ideaPath = (idea: Pick<MarketIdea, "id" | "status">): string =>
  `${MARKET_BASE}/ideas?${new URLSearchParams({
    estado: idea.status,
    idea: String(idea.id),
  })}`;

export const opportunitiesPath = `${MARKET_BASE}/prospectos`;

/** Former path of the Prospects tab, redirected so old links keep working. */
export const LEGACY_OPPORTUNITIES_PATH = `${MARKET_BASE}/oportunidades`;

/** Maps a legacy /inteligencia/oportunidades[/...] path to /inteligencia/prospectos[/...]. */
export const prospectsPathOf = (legacyPathname: string): string =>
  opportunitiesPath + legacyPathname.slice(LEGACY_OPPORTUNITIES_PATH.length);
